/**
 * Canonical root paths for each content library.
 * Use these constants throughout the codebase to ensure consistency.
 */
export const LIBRARY_ROOTS = {
  MUSIC: '/music',
  SFX: '/sfx',
  MOTION_GRAPHICS: '/motion-graphics',
  STOCK_FOOTAGE: '/stock-video',
} as const;
